import { atomWithStorage } from 'jotai/utils';

export const CAMPAING_STORAGE_KEY = 'precifield.campaign';

const sessionStorageForCampaign = {
  getItem: (key: string): number | undefined => {
    const v = sessionStorage.getItem(key);
    if (v === null) return undefined;
    try {
      return JSON.parse(v) as number | undefined;
    } catch {
      return undefined;
    }
  },
  setItem: (key: string, value: number | undefined) => {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  removeItem: (key: string) => sessionStorage.removeItem(key),
};

export const campaignAtom = atomWithStorage<number | undefined>(
  CAMPAING_STORAGE_KEY,
  undefined,
  sessionStorageForCampaign,
);
